<template>
  <div id="contact-list" :class="[$mq]" v-if="$mq != 'portrait'">
    <div class="title">
      {{ title }}
      <div @click="add" class="add">{{ "add" | i18n }}</div>
    </div>
    <div class="clear" style="height: 20px"></div>
    <div class="contact_list">
      <ContactCard
        v-for="(contact, key) in contacts"
        :contact="contact"
        :key="contact.id"
      ></ContactCard>
    </div>
  </div>
</template>

<script>
import i18n from "@/i18n";
import ContactCard from "@/components/ui/cards/mini/Contact";

export default {
  components: { ContactCard },
  props: { contacts: Array, entity: String },
  data() {
    return {
      title: this.entity == "team" ? i18n.t("staff") : i18n.t("contact-list"),
    };
  },
  computed: {},
  methods: {
    add() {
      // var event = ( this.$store.getters.isEventSelected )? this.$store.getters[ 'events/getCurrentEvent' ]() : false
      // var event_name = ( event )? this.$root.formatEventUrl( event.name, event.edition ).replace( '/event/', '' ) : ''
      // var page = ( event )? 'event_persons_add' : 'persons_add'
      // this.$router.push( { name: page, params: { event: event_name } } )

      var type = this.entity == "team" ? "staff" : "contact";
      this.$popup.searchperson({
        type: type,
        entity: this.entity,
        id: this.$route.params.id,
        title: i18n.t("search.person.title"),
        message: i18n.t("search.person.message"),
        btnSearch: i18n.t("search.person.label"),
        btnSuccess: i18n.t("create." + type),
        btnCancel: i18n.t("cancel"),
      });
    },
  },
  created() {
    var self = this;
  },

  filters: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#contact-list {
  background-color: $complem-color-light;
  position: fixed;
  top: calc(#{$header-height} + #{$topbar-height});
  right: 0;
  height: calc(100% - #{$header-height} - #{$topbar-height});
  overflow-y: auto;
  /*border-left: 3px solid $complem-color-dark;*/
  border-left: 5px solid #fff;

  .title {
    padding-bottom: 5px;
    background: url("/img/users.svg") no-repeat left 10px center;
    background-size: 15px;
    padding-left: 35px;
    position: relative;

    .add {
      content: "";
      position: absolute;
      /* width: 40px; */
      /* height: 25px; */
      /* border: 1px solid #000; */
      /* border-radius: 50%; */
      background: url(/img/add_b.svg);
      background-repeat: no-repeat;
      background-size: 12px;
      background-position: left center;
      padding-left: 20px;
      top: 0;
      right: 0;
    }
  }
}
.development #contact-list {
  top: calc(#{$header-height} + #{$topbar-height} + #{$height-development});
}
</style>
